import { axios, AxiosConfig } from '~/modules/http/axios'
import { User } from '~/interfaces'
import { LocalStorageManager } from '~/modules/localStorage'
import { HttpStatusCode } from '~/protocols/http'

const { REACT_APP_API_VSC_URL: apiBaseUrl, REACT_APP_LOGIN_API_URL: loginApiURL } = process.env

const onRejectRefreshToken = async onRejected => {
  try {
    const session = LocalStorageManager.ReadEncryptedData<User>('session')

    const { config, response } = onRejected
    const isAuthorized = response?.status !== HttpStatusCode.unauthorized

    if (config.url === '/refresh-token') {
      throw 'error'
    }

    if (isAuthorized) {
      return await Promise.reject(onRejected)
    }

    const { setAxiosAuth } = AxiosConfig
    axios.defaults.baseURL = loginApiURL
    const data = await axios.post('/refresh-token', {
      refresh_token: session.refresh_token
    })
    axios.defaults.baseURL = apiBaseUrl

    config.headers.Authorization = `Bearer ${data.data.access_token}`
    setAxiosAuth(data.data.access_token)

    session.access_token = data.data.access_token
    session.refresh_token = data.data.refresh_token || ''

    LocalStorageManager.WriteEncryptedData('session', session)
    return await axios(config)
  } catch (error) {
    const { response } = onRejected
    const isUnauthorized = response?.status === HttpStatusCode.unauthorized

    if (isUnauthorized) {
      LocalStorageManager.DeleteData('session')
      window.location.href = '/login'
      return error
    }

    return await Promise.reject(response)
  }
}

const RefreshToken = [undefined, onRejectRefreshToken]

export { RefreshToken, onRejectRefreshToken }
